import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Municipio } from 'src/app/models';
import { ValidRoles } from 'src/app/utils/directives/validateRoles/validate-roles.directive';
import { MunicipalityTokenService } from '../municipality-token/municipality-token.service';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class FsessionService {
  permission: {};
  headers: any;

  private municipalityTokenService = inject(MunicipalityTokenService);
  private msalService = inject(MsalService);

  private _appState: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _currentCity: BehaviorSubject<number> = new BehaviorSubject<number>(undefined);
  _currentLang: BehaviorSubject<string> = new BehaviorSubject<string>('');
  _userCities: BehaviorSubject<Municipio[]> = new BehaviorSubject<Municipio[]>([]);

  private _currentRole = new BehaviorSubject<number | null>(null);

  constructor() { }

  agregarActualizar(variable: string, valor: string, storage = 'session') {
    var datos = this.capturarSession(storage);
    datos[variable] = valor;
    sessionStorage.setItem(storage, JSON.stringify(datos));
  }

  deleteVariable(variable: string, storage = 'session') {
    var datos = this.capturarSession();
    delete datos[variable];
    sessionStorage.setItem(storage, JSON.stringify(datos));

    if (variable === 'dato40') {
      this._currentRole.next(null);
    }
  }

  getAppState() {
    return this._appState.asObservable()
  }

  setAppState(state: boolean) {
    this._appState.next(state);
  }

  capturarSession(storage = 'session') {
    var datos = {};

    if (sessionStorage.getItem(storage)) {
      datos = JSON.parse(sessionStorage.getItem(storage));
    }

    return datos;
  }

  optenerValor(variable: any, storage = 'session') {
    let datos = this.capturarSession(storage);

    switch (variable) {
      case 'idusuario':
        const activeAccount = this.msalService.instance.getActiveAccount();
        return activeAccount.idTokenClaims['extension_fviu'];
      case 'dato4':
        return this.municipalityTokenService.getMunicipalityId()
      case 'paquetes':
        return this.municipalityTokenService.getModules()
      case 'dato43':
        return this.municipalityTokenService.getMunicipalityPermissions()
      case 'dato40':
      case 'dato47':
        return this.municipalityTokenService.getUserMunicipalityRole()
      default:
        if (datos[variable] == undefined) {
          return false;
        } else {
          return datos[variable];
        }
    }
  }

  closeSession() {
    sessionStorage.clear();
  }

  setPermission(permission) {
    this.permission = permission;
    sessionStorage.setItem('permSession', JSON.stringify(this.permission))
  }


  getPermission() {
    if (this.permission == undefined) {
      this.permission = this.capturarSession('permSession');
    }

    return this.permission;
  }

  getHeaders() {
    if (this.headers == undefined) {
      this.headers = this.capturarSession('headers');
    }

    return this.headers;
  }

  setCity(city: string | number) {
    this._currentCity.next(Number(city));
  }

  getSubscribeCity() {
    return this._currentCity.asObservable();
  }

  setLanguage(lang: string) {
    this.agregarActualizar('language', lang);
    localStorage.setItem('ui_locales', lang);
    this._currentLang.next(lang);
  }

  getSubscribeLang() {
    return this._currentLang.asObservable();
  }

  setUserCities(cities: Municipio[]) {
    this._userCities.next(cities)
  }

  getUserCities(): Observable<Municipio[]> {
    return this._userCities.asObservable();
  }

  /**
 * Verifica en la sesión si el usuario tiene el rol especificado
 * 
 * @param rol El rol a verificar
 * @returns Si el usuario tiene el rol
 */
  hasRole(rol: ValidRoles): boolean {
    const idRolUser = +this.optenerValor('dato40');
    return idRolUser === rol;
  }

  storeSession() { }

  /**
   * Establece el rol en la sesión
   * @param role El rol a establecer
   */
  setRole(role: number | string) {
    const n = Number(role);
    const roleNum = Number.isFinite(n) && !Number.isNaN(n) ? n : null;
    // if (roleNum !== null) {
    //   this.agregarActualizar('dato40', roleNum.toString());
    // } else {
    //   this.deleteVariable('dato40');
    // }
    this._currentRole.next(roleNum);
  }

  /**
   * Obtiene el rol de la sesión
   * @returns 
   */
  getRole$(): Observable<number | null> {
    const raw = this.optenerValor('dato40');
    if (raw === false) {
      this._currentRole.next(null);
    } else {
      const n = Number(raw);
      this._currentRole.next(Number.isFinite(n) && !Number.isNaN(n) ? n : null);
    }

    return this._currentRole.asObservable();
  }

}
